export default theme => ({
  root: {
    top: 0,
    transform: `scale(1) translate(0%, -${theme.typography.pxToRem(200)})`,
    transformOrigin: '100% 0%',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '75%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '55%',
    }
  },
  root2: {
    top: 0,
    transform: `scale(1) translate(0%, -${theme.typography.pxToRem(10)})`,
    transformOrigin: '100% 0%',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '75%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '55%',
      marginTop: '15px',
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  root3: {
    top: 0,
    transform: `scale(1) translate(0%, -${theme.typography.pxToRem(10)})`,
    transformOrigin: '100% 0%',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '75%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '55%',
      marginTop: '-55px',
      marginBottom: '20px'
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

})